import { Component, Inject, OnInit } from '@angular/core';
import { AssetMaintenanceRecordModel } from '../../../models/asset-maintenance-record.model';
import { UtilsService } from '../../../shared/utils.service';
import { UserPublicProfileComponent } from '../../../shared/user-public-profile/user-public-profile.component';
import {
  AssetMaintenanceSchedulesViewComponent
} from '../../asset-maintenance-schedules/asset-maintenance-schedules-view/asset-maintenance-schedules-view.component';
import { AppService } from '../../../app.service';
import { ApiRequestService } from '../../../shared/api-request.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AssetsService } from '../../assets.service';
import { AssetMaintenanceRecordsService } from '../asset-maintenance-records.service';

@Component({
  selector: 'app-asset-maintenance-records-view',
  templateUrl: './asset-maintenance-records-view.component.html',
  styleUrls: ['./asset-maintenance-records-view.component.scss']
})
export class AssetMaintenanceRecordsViewComponent implements OnInit {
  asset_maintenance_record: AssetMaintenanceRecordModel = new AssetMaintenanceRecordModel();

  constructor(
    public app: AppService,
    private api: ApiRequestService,
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    public assetsService: AssetsService,
    public assetMaintenanceRecordsService: AssetMaintenanceRecordsService
  ) {}

  ngOnInit() {
    const asset_id = this.dialogData?.asset_id;
    const asset_maintenance_record_id = this.dialogData?.asset_maintenance_record_id;

    if (typeof asset_id === 'number' && asset_id > 0) {
      this.asset_maintenance_record.asset_id = asset_id;
    }

    if (typeof asset_maintenance_record_id === 'number' && asset_maintenance_record_id > 0) {
      this.find(asset_maintenance_record_id);
    }
  }

  /**
   * Retrieves the Maintenance Record with the specified ID.
   *
   * @param {number} id - The unique identifier of the maintenance record to retrieve.
   * @return {void}
   */
  private find(id: number): void {
    this.api
      .makeRequest('get', `v2/assets/${this.asset_maintenance_record.asset_id}/maintenance-records/${id}`)
      .then((response) => {
        this.asset_maintenance_record = response.data as AssetMaintenanceRecordModel;
      })
      .catch((errorResponse) => {
        this.utils.handleAPIErrors(errorResponse);
      });
  }

  /**
   * Open the user's public profile dialog.
   *
   * @param hash
   */
  onUserPublicView(hash: string) {
    this.utils.showComponentDialog(
      UserPublicProfileComponent,
      hash,
      { width: '90%' },
      () => {
        // Refresh the list regardless of how the dialog is closed.
      }
    );
  }

  /**
   * Opens a dialog to view the details of a specific asset maintenance schedule.
   *
   * @param {number} schedule_id - The unique identifier of the asset maintenance schedule to be viewed.
   * @return {void} Does not return anything.
   */
  onViewSchedule(schedule_id: number): void {
    this.utils.showComponentDialog(
      AssetMaintenanceSchedulesViewComponent,
      {
        asset_id: this.asset_maintenance_record.asset_id,
        asset_maintenance_schedule_id: schedule_id
      },
      { width: '700px' }
    );
  }
}
